<template>
    <!-- menu group like the native settings list: cog, title, chevron, inset dividers -->
    <v-card flat rounded="lg" :color="backgroundColor">
        <!-- same color as the card: the theme's "transparent" is an 8-digit hex Vuetify renders as black -->
        <v-list :color="backgroundColor" class="py-0">
            <template v-for="(item, index) in items">
                <v-list-item
                    :key="item.key"
                    :ripple="false"
                    :style="item.key === selected ? { background: SELECTED_BACKGROUND } : null"
                    @click="$emit('select', item.key)"
                >
                    <v-list-item-icon class="mr-4">
                        <v-icon :color="iconColor">mdi-cog</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title :style="{ color: item.key === selected ? iconColor : textColor }">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                        <v-icon :color="iconColor">mdi-chevron-right</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index < items.length - 1" :key="`${item.key}-divider`" inset/>
            </template>
        </v-list>
    </v-card>
</template>

<script>
// subtle highlight of the open section in the split view (native: light grey row, grey text)
const SELECTED_BACKGROUND = 'rgba(0, 0, 0, 0.06)';

export default {
    props: {
        // [{ key, title }]
        items: {
            type: Array,
            default: () => [],
        },
        selected: {
            type: String,
            default: null,
        },
        textColor: {
            type: String,
            default: null,
        },
        iconColor: {
            type: String,
            default: null,
        },
        backgroundColor: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            SELECTED_BACKGROUND,
        };
    },
};
</script>
